// AWS Configuration for Amplify services

import { Amplify } from 'aws-amplify';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { AWS_REGION as region, IDENTITY_POOL_ID as identityPoolId } from './env';

// AWS configuration object
export const awsConfig = {
  aws_project_region: region,
  aws_cognito_identity_pool_id: identityPoolId,
  // Add credentials provider configuration
  credentials: fromCognitoIdentityPool({
    clientConfig: { region },
    identityPoolId
  }),
  // Add specific configuration for Rekognition FaceLiveness
  aws_rekognition_region: region,
  aws_rekognition_identityPoolId: identityPoolId
};

// Initialize Amplify with the configuration
Amplify.configure(awsConfig);

// Export configuration values for use in components
export { region, identityPoolId };